<div id="{{ id }}" class="mobile-interactive bespoke-slide {{ classes }}">
    <div class="scroll">
        <div class="scroll__text">Scroll or use your keyboard to continue</div>
    </div>
    {{#if slide.img_list}}
        <div class="slide__bullet-group">
        {{#each slide.img_list as img_item, n}}
            <div class="step step--{{ n }}">
                {{#if img_item.type == 'Image' && img_item.text}}
                <div class="slide__text slide__text--{{ n + 1 }} slide__text--interactive">
                    <div class="slide__text-inner">{{ img_item.text }}</div>
                </div>
                {{elseif img_item.type == 'Aside'}}
                <div class="slide__text slide__text--{{ n + 1 }} slide__text--interactive">
                    <Modal slideIndex={{i}} modalIndex={{n}} modal={{$science_asides[img_item.slug]}} />
                </div>
                {{/if}}

                {{#if img_item.bg_img}}
                <div class="media-outer">
                    <img src="{{img_item.bg_img}}" alt="" />
                </div>
                {{/if}}
            </div> 
        {{/each}}
        {{#if slide.footnote}}
            <div class="i-pro__footnote">{{ slide.footnote }}</div>
        {{/if}}
        </div>
    {{/if}}

    {{#if slide.modal }}
        {{#each slide.modal as modal, n}}
        <Modal slideIndex={{i}} modalIndex={{n}} :modal />
        {{/each}}
    {{/if}}
</div>

<script>
import Modal from '../../Modal.html'
export default {

    components: {
        Modal,
    },

    data() {
        return {
            slide: {},
            i: 0,
        }
    },

    computed: {
        id: slide => slide.slug ? slide.slug : slide._id,
        classes: ($current_slide, i) => {
            let classes = i == $current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < $current_slide) classes += ' bespoke-before'; 
            if (i > $current_slide) classes += ' bespoke-after';
            return classes;
        }
    },
}
</script>